/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { NbThemeService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import 'reflect-metadata';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthService } from './auth/auth.service';
import { Constants } from './shared/Constants';
import { LoadingService } from './shared/services/loading.service';
import { LocalStoreManager } from './shared/services/local-store-manager.service';
import { SharedService } from './shared/services/shared.service';
@Component({
	selector: 'ngx-app',
	templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
	showUpdateAvailable = false;
	showGlobalLoader$: BehaviorSubject<boolean> = new BehaviorSubject(null);
	constructor(private translate: TranslateService, private loadingService: LoadingService, private themeService: NbThemeService, private authService: AuthService, private localStoreManager: LocalStoreManager, private swUpdate: SwUpdate, private sharedService: SharedService) {
		this.swUpdate.versionUpdates.pipe(
			filter((x => x.type == 'VERSION_READY'))
		).subscribe(() => {
			this.showUpdateAvailable = true;
		});

		this.translate.setDefaultLang(this.sharedService.getCurrentLanguage());
		const theme = this.sharedService.getThemePreference();
		this.themeService.changeTheme(theme);
	}

	async ngOnInit(): Promise<void> {
		this.showGlobalLoader$ = this.loadingService.isLoading$;
		const user = await this.authService.getAuthUser();
		const avoidSavingUrl = window.location.href.indexOf('auth') > -1 || window.location.href.indexOf('login') > -1 || window.location.href.indexOf('cart') > -1 || window.location.pathname == '/';  
		if (!user && !avoidSavingUrl) {
			this.localStoreManager.savePermanentData(window.location.href, Constants.DIRECT_LINK);
		}
	 }
	

	removeUpdateAlert(): void {
		this.showUpdateAvailable = false;
	}

	update(): void {
		window.location.reload();
		this.showUpdateAvailable = false;
	}
}
